import React from "react";
import Device from "./Device";

export const Cols21 = ({children, mobileReverse}) => <div className={"grid grid-cols-1 sm:grid-cols-3 md:gap-4"}>
  <div className={"col-span-2 mt-8 md:mt-0 " + (mobileReverse && Device.xs ? "order-2" : "order-1")}>
    {children[0]}
  </div>

  <div className={"col-span-1 " + (mobileReverse && Device.xs  ? "order-1" : "order-2")}>
    {children[1]}
  </div>
</div>
